import { BillableOperation } from "src/types/billableOperation";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const billableOperationsApi = ssoApi
  .enhanceEndpoints({ addTagTypes: [CacheKeys.BILLABLE_OPERATIONS] })
  .injectEndpoints({
    endpoints: builder => ({
      billableOperations: builder.query<BillableOperation[], string>({
        query: query => ({ url: `${Endpoints.BILLABLE_OPERATIONS}?softwareId=${query}` }),
        providesTags: [CacheKeys.BILLABLE_OPERATIONS],
      }),
    }),
  });

export const { useBillableOperationsQuery } = billableOperationsApi;
